// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"339":"storefront","884":"admin"}[chunkId] || chunkId) + "." + {"73":"b1595858","339":"d1ad02df","445":"b9d386a1","556":"6145ae55","884":"d85f4e36"}[chunkId] + ".chunk.js";
};